<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md4 lg4>
      <v-card class="elevation-1 pa-3">
        <v-card-title>
          {{ $t('請先登入系統') }}
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="!!error"
            color="warning"
            icon="mdi-alert"
            class="mb-5"
            outlined>
            {{ error }}
          </v-alert>
          <v-form method="post" @submit.prevent="submit">
            <input type="hidden" name="remember" value="true">
            <v-text-field
              prepend-icon="mdi-cellphone"
              name="account"
              :label="$t('手機號碼')"
              type="text"
              v-model="phone"
              :error-messages="errorMessage"
            />
            <v-text-field
              v-show="isSent"
              type="text"
              prepend-icon="mdi-key"
              name="code"
              :label="$t('認證碼')"
              v-model="code"
              v-on:keyup.enter="submit"
              :error-messages="codeErrorMessage"/>
          </v-form>
        </v-card-text>
        <v-card-actions class="flex-column">
          <v-btn v-if="isSent" block color="primary" :loading="isLoading" @click="submit">
            {{ $t('登入系統') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            block
            :color="isSent ? 'secondary' : 'primary'"
            :loading="isLoading" @click="getCode"
            :disabled="phone.length <= 6"
            class="mt-3"
          >
            <v-icon>mdi-email-send-outline</v-icon>
            {{ isSent ? $t('重新發送驗證碼') : $t('取得簡訊驗證碼') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import API from '../api';
import { setApiToken } from '../api/modules/core';

export default {
  props: {
    error: String,
  },

  data() {
    return {
      phone: '',
      code: '',
      attempts: 0,
      isSent: false,
      isLoading: false,
      errorMessage: null,
      codeErrorMessage: null,
      response: null,
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$store.getters.auth) {
        next(to.query.redirect);
      }
    })
  },

  methods: {
    async submit() {
      this.isLoading = true;
      this.isLoginFailure = false;
      try {

        if (this.attempts >= 5) {
          alert(this.$t('系統目前無法登入，請聯絡開通中心 02-8227-3308分機20及21。'));
          this.isLoading = false;
          return;
        }

        this.attempts++;
        if (this.code != this.response.code) {
          this.codeErrorMessage = this.$t('驗證碼錯誤');
          this.isLoading = false;
          return;
        }

        setApiToken(this.response.token);
        let result = await this.$store.dispatch('me');
        if (result) {
          this.$router.push({
            name: 'query'
          });
        }
      } catch (error) {
        console.error(error);
        alert(this.$t('系統目前無法登入，請聯絡開通中心 02-8227-3308分機20及21。'));
      }
      this.isLoading = false;
    },

    async getCode() {
      this.isLoading = true;
      this.errorMessage = null;

      try {
        let { data } = await API.auth.sendCode(this.phone);
        this.response = data;
        this.isSent = true;
        if (data.no_code) {
          this.code = this.response.code;
          this.submit();
        }
      } catch(error) {
        if (error.response.status == 422) {
          this.errorMessage = this.$t('此電話號碼不存在');
        } else {
          console.error(error);
          alert(this.$t('無法取的認證碼，請聯絡開通中心 02-8227-3308分機20及21。'));
        }
      }
      this.isLoading = false;
    },
  },
}
</script>
